export default __webpack_public_path__ + "static/media/metal_nomad_icon.da1f5792.png";